/* eslint-disable react/jsx-wrap-multilines */
import React, { useEffect, useState } from 'react';
import moment from 'moment';
// import { useMount } from 'react-use';
import {
  Grid,
  Card,
  CardContent,
  Alert,
  Typography,
  Stack,
  Button,
  FormGroup,
  FormControlLabel,
  Switch,
  ToggleButton,
  ToggleButtonGroup,
  TextField,
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

const RobotDisturbInputForm = (props) => {
  const { onSave, value: propValue } = props;
  const [initialValue, setInitial] = useState({
    toggle: false,
    day: [],
    startTime: '22:00',
    endTime: '07:00',
    error: null,
  });
  const [value, setValue] = useState({ ...initialValue });

  const changeValue = (v) => {
    const { toggle, day, startTime, endTime } = v;
    if (toggle) {
      if (day.length === 0) {
        return setValue({ ...v, error: '실행 요일을 선택하세요.' });
      }
      if (startTime === endTime) {
        return setValue({
          ...v,
          error: '시작 시간과 종료 시간은 같을 수 없습니다.',
        });
      }
    }
    return setValue({ ...v, error: '' });
  };

  // useMount(() => {
  //   if (propValue && '_id' in propValue) {
  //     const {
  //       repeat,
  //       execTime,
  //       expTime,
  //       repeatValue: {
  //         value: { day },
  //       },
  //     } = propValue;
  //     setInitial({
  //       toggle: repeat,
  //       day,
  //       startTime: moment(execTime).format('HH:mm'),
  //       endTime: moment(expTime).format('HH:mm'),
  //     });
  //     changeValue({
  //       toggle: repeat,
  //       day,
  //       startTime: moment(execTime).format('HH:mm'),
  //       endTime: moment(expTime).format('HH:mm'),
  //     });
  //   }
  // });

  useEffect(() => {
    if (propValue && '_id' in propValue) {
      const {
        repeat,
        execTime,
        expTime,
        repeatValue: {
          value: { day },
        },
      } = propValue;
      setInitial({
        toggle: repeat,
        day,
        startTime: moment(execTime).format('HH:mm'),
        endTime: moment(expTime).format('HH:mm'),
      });
      changeValue({
        toggle: repeat,
        day,
        startTime: moment(execTime).format('HH:mm'),
        endTime: moment(expTime).format('HH:mm'),
      });
    } else {
      setInitial({
        toggle: false,
        day: [],
        startTime: '22:00',
        endTime: '07:00',
        error: null,
      });
      changeValue({
        toggle: false,
        day: [],
        startTime: '22:00',
        endTime: '07:00',
        error: null,
      });
    }
  }, [propValue]);

  const handleChange = (e) => {
    const { name, value: v } = e.target;
    return changeValue({ ...value, [name]: v });
  };

  const handleWeekdayClick = (e, newVal) => {
    return changeValue({ ...value, day: newVal });
  };

  const handleCommandToggle = (e, v) => {
    let obj = value;
    if (v) {
      obj = initialValue;
    }
    return changeValue({ ...obj, toggle: v });
  };

  const handleTimeChange = (e) => {
    const { name, value: v } = e.target;
    return setValue({ ...value, error: '', [name]: v });
  };

  const handleSaveClick = () => {
    const { error } = value;
    if (!error && onSave) {
      onSave(value);
    }
  };

  return (
    <Card>
      <CardContent>
        <Grid container rowSpacing={1}>
          <Grid
            item
            xs={12}
            display="inline-flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography variant="h6" component="h6">
              방해금지모드
            </Typography>
            <Button
              color="secondary"
              variant="contained"
              onClick={handleSaveClick}
            >
              저장
            </Button>
          </Grid>
          <Grid item xs={12} margin={1}>
            <FormGroup>
              <FormControlLabel
                control={
                  <Switch
                    color="secondary"
                    checked={value.toggle}
                    onChange={handleCommandToggle}
                  />
                }
                label={
                  value.toggle
                    ? '방해금지모드를 자동으로 실행합니다.'
                    : '방해금지모드를 실행하지 않습니다.'
                }
              />
            </FormGroup>
          </Grid>
          {value.error && (
            <Grid item xs={12}>
              <Alert color="error">{value.error}</Alert>
            </Grid>
          )}
          {value.toggle && (
            <Grid item container xs={12} spacing={1}>
              <Grid item xs={12}>
                <Stack gap={1}>
                  <Typography variant="body2">요일 설정</Typography>
                  <ToggleButtonGroup
                    {...{
                      color: 'secondary',
                      value: value.day,
                      onChange: handleWeekdayClick,
                    }}
                    sx={{ width: '100%', '& button': { width: '100%' } }}
                  >
                    {moment.weekdaysShort().map((l, i) => (
                      <ToggleButton value={i} key={`weekday_${l}`}>
                        {l}
                      </ToggleButton>
                    ))}
                  </ToggleButtonGroup>
                </Stack>
              </Grid>
              <Grid item xs={6}>
                <Stack gap={1} minWidth="30%" width="100%">
                  <Typography variant="body2">시작</Typography>
                  <TextField
                    {...{
                      name: 'startTime',
                      type: 'time',
                      value: value.startTime,
                      onBlur: handleChange,
                      onChange: handleTimeChange,
                    }}
                  />
                </Stack>
              </Grid>
              <Grid item xs={6}>
                <Stack gap={1} minWidth="30%" width="100%">
                  <Typography variant="body2">종료</Typography>
                  <TextField
                    {...{
                      name: 'endTime',
                      type: 'time',
                      value: value.endTime,
                      onBlur: handleChange,
                      onChange: handleTimeChange,
                    }}
                  />
                </Stack>
              </Grid>
            </Grid>
          )}
          <Grid item xs={12} display="inline-flex" alignItems="center">
            <InfoIcon color="secondary" sx={{ mr: 1 }} />
            <Typography variant="body2">
              방해금지모드 자동 실행을 선택하면 지정된 요일과 시간에
              방해금지모드가 자동으로 실행됩니다.
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default RobotDisturbInputForm;
